
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

interface StatusChangeDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  selectedItem: any;
  statusChangeNotes: string;
  onNotesChange: (value: string) => void;
  newStatus: string;
  onStatusChange: (value: string) => void;
  onSave: () => void;
  type: 'recommendation' | 'trial';
}

// Define valid status options that match EXACTLY with database constraints
const STATUS_OPTIONS = {
  recommendation: [
    'Bekliyor',
    'Iletisime Gecildi',
    'Gorüsme Ayarlandi',
    'Satis Yapildi',
    'Ulasilamadi',
    'Olumsuz',
  ],
  trial: [
    'Bekliyor',
    'Iletisime Gecildi',
    'Gorüsme Yapildi', // Exactly as in DB constraint
    'Satis Yapildi',
    'Gelmedi',
    'Iptal'
  ],
};

// Display labels for statuses (can have Turkish characters)
const STATUS_LABELS = {
  'Bekliyor': 'Bekliyor',
  'Iletisime Gecildi': 'İletişime Geçildi',
  'Gorüsme Yapildi': 'Görüşme Yapıldı',
  'Satis Yapildi': 'Satış Yapıldı',
  'Gelmedi': 'Gelmedi',
  'Iptal': 'İptal'
};

export const StatusChangeDialog = ({
  open,
  onOpenChange,
  selectedItem,
  statusChangeNotes,
  onNotesChange,
  newStatus,
  onStatusChange,
  onSave,
  type,
}: StatusChangeDialogProps) => {
  if (!selectedItem) return null;

  const statusOptions = STATUS_OPTIONS[type];
  const title = type === 'recommendation' ? 'Koç Önerisi Durumu' : 'Ücretsiz Görüşme Durumu';

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        <div className="grid gap-4 py-4">
          <div className="grid gap-2">
            <Label>İsim</Label>
            <div className="p-2 bg-secondary rounded">
              {selectedItem.name_surname}
            </div>
          </div>
          <div className="grid gap-2">
            <Label>Mevcut Durum</Label>
            <div className="p-2 bg-secondary rounded">
              {STATUS_LABELS[selectedItem.status as keyof typeof STATUS_LABELS] || 'Bekliyor'}
            </div>
          </div>
          <div className="grid gap-2">
            <Label htmlFor="status">Yeni Durum</Label>
            <Select onValueChange={onStatusChange} value={newStatus}>
              <SelectTrigger>
                <SelectValue placeholder="Durum seçin" />
              </SelectTrigger>
              <SelectContent>
                {statusOptions.map((status) => (
                  <SelectItem key={status} value={status}>
                    {STATUS_LABELS[status as keyof typeof STATUS_LABELS]}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
          <div className="grid gap-2">
            <Label htmlFor="notes">Notlar</Label>
            <Textarea
              id="notes"
              value={statusChangeNotes}
              onChange={(e) => onNotesChange(e.target.value)}
              placeholder="Durum değişikliği ile ilgili notlar..."
            />
          </div>
        </div>
        <DialogFooter>
          <Button onClick={onSave} disabled={!newStatus}>
            Kaydet
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
